import "babel-polyfill";
import "es6-promise/auto";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "@/styles/common.scss";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import { Collapse, Loading } from "element-ui";
import locale from "element-ui/lib/locale/lang/ko";
import Datepicker from "vuejs-datepicker";
import Tabs from "vue-material-tabs";
import VCalendar from "v-calendar";

Vue.config.productionTip = true;
Vue.use(ElementUI, { locale });
Vue.use(Collapse);
Vue.use(Loading);
Vue.use(Datepicker);
Vue.use(Tabs);
Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});
new Vue({
  router,
  store,
  beforeCreate() {
    if (this.$store.state.isLogin) {
      this.$store.dispatch("getAccountInfo");
      this.$store.dispatch("getNewRequestList");
    }
  },
  render: (h) => h(App),
}).$mount("#app");
